var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrasad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0,18.138c0.212-0.468,0.595-0.616,1.083-0.615 c7.278,0.004,14.555,0.004,21.833,0c0.489,0,0.872,0.147,1.083,0.615c0,0.438,0,0.875,0,1.313 c-0.013,0.053-0.029,0.105-0.038,0.158c-0.381,2.238-2.352,3.853-4.56,3.847c-4.974-0.014-9.948,0.01-14.922-0.014 c-1.655-0.008-2.915-0.804-3.815-2.18C0.303,20.71,0.128,20.089,0,19.451C0,19.013,0,18.576,0,18.138z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.853,14.058c-0.004,1.61-1.319,2.922-2.924,2.918 c-1.597-0.005-2.922-1.336-2.92-2.933c0.002-1.61,1.326-2.91,2.959-2.905C6.57,11.142,7.857,12.445,7.853,14.058z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.147,14.059c-0.005-1.613,1.282-2.917,2.884-2.921 c1.634-0.005,2.958,1.294,2.96,2.904c0.002,1.597-1.323,2.929-2.919,2.934C17.467,16.981,16.152,15.669,16.147,14.059z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.011,11.137c1.614,0.002,2.912,1.307,2.909,2.925 c-0.003,1.604-1.325,2.918-2.931,2.914c-1.604-0.004-2.911-1.324-2.909-2.937C9.083,12.428,10.388,11.136,12.011,11.137z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.474,5.84c1.995,0.001,3.397,1.953,2.767,3.841 c-0.076,0.228-0.195,0.349-0.438,0.418c-0.826,0.237-1.504,0.711-2.041,1.383c-0.222,0.277-0.365,0.276-0.591-0.005 c-0.554-0.692-1.257-1.166-2.111-1.397c-0.22-0.06-0.294-0.202-0.356-0.385C5.063,7.791,6.465,5.839,8.474,5.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.452,8.75c0.002,0.372-0.072,0.729-0.204,1.076 c-0.048,0.127-0.128,0.2-0.263,0.236c-0.887,0.243-1.616,0.727-2.186,1.451c-0.189,0.24-0.352,0.233-0.546-0.01 c-0.567-0.714-1.287-1.198-2.167-1.438c-0.145-0.039-0.22-0.116-0.275-0.251c-0.757-1.842,0.648-3.958,2.643-3.973 c1.503-0.011,2.69,0.967,2.957,2.443C18.439,8.437,18.439,8.594,18.452,8.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.009,0.543C14,0.545,15.407,2.506,14.772,4.389 c-0.073,0.217-0.184,0.343-0.42,0.409C13.513,5.03,12.835,5.516,12.29,6.19c-0.214,0.265-0.364,0.267-0.576,0.004 c-0.544-0.675-1.221-1.166-2.061-1.393C9.388,4.729,9.289,4.577,9.218,4.349C8.62,2.453,10.02,0.542,12.009,0.543z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrasad);
export default __webpack_public_path__ + "static/media/prasad.b86fdfb5.svg";
export { ForwardRef as ReactComponent };